(function (Drupal, once) {
  Drupal.behaviors.analytics = {
    attach: function (context) {
      const bodyElement = once('ga4AnalyticsOnce', 'body', context);
      bodyElement.forEach(ga4ProcessCallback);
    }
  };

  function ga4ProcessCallback(value, index) {
    if (typeof dataLayer === 'undefined' ) {
      return;
    }
    // page_view event
    let pl = window.location.href.replace(/^(https?:|)\/\//, '');
    // remove the trailing slash if it exists.
    if (pl.slice(-1) == '/') {
      pl = pl.substring(0,pl.length-1);
    }
    dataLayer.push({event: 'page_view', page_title: document.title, page_location: pl});
    /*
     * Global menu events will be set up in
     * /web/modules/texas_custom/js/food-menu-grid.js with the other menu
     * functionality.
     */
    // CTA click event (Link buttons only).
    document.querySelectorAll('[data-section]').forEach(function(el){
      if( dataLayer !== undefined ) {
        el.addEventListener('click', function(e){
          dataLayer.push({
            event:'cta_click',
            link_text: e.target.innerHTML,
            site_section: e.target.dataset.section,
            link_url: e.target.href
          });
        });
      }
    });

    // CTA click event for the hero image carousel items.
    $('.txrh-hero-carousel .slick-slide a').click(function(e) {
      const carousel_tile = $(this).find('.carousel-item__image').data('carousel-tile');
      const link_text = $(this).attr('title') ?? 'Order Now';
      const idx = parseInt($(this).parent().parent().parent().attr('data-slick-index')) + 1;

        dataLayer.push({
          event:'cta_click',
          link_text: link_text,
          site_section: 'Hero Carousel',
          carousel_tile: carousel_tile,
          carousel_index: idx,
          link_url: $(this).attr('href')
        });

        console.log('New Click Handler before', carousel_tile, link_text, idx, $(this).attr('href'), dataLayer);
    });

    // let carouselImages = document.querySelectorAll('.txrh-hero-carousel .slick-slide a .carousel-item__image');
    // if ( carouselImages.length ) {
    //   carouselImages.forEach(function(el){
    //     console.log('Carousel IMAGE Click', el.getAttribute('data-carousel-tile'));
    //     if ( el.getAttribute('data-carousel-tile') != '' ) {
    //       console.log('Carousel IMAGE Click');
    //       el.addEventListener('click', function(e){
    //
    //         let linkText = e.target.parentNode.getAttribute('title') ?? 'Order Now';
    //         let idx = parseInt(e.target.parentNode.parentNode.parentNode.getAttribute('id').replace(/slick-slide/, ''))+1;
    //         console.log('Carousel IMAGE Click', e.target.parentNode.getAttribute('title'), idx);
    //         dataLayer.push({
    //           event:'cta_click',
    //           link_text: linkText,
    //           site_section: 'Hero Carousel',
    //           carousel_tile: el.getAttribute('data-carousel-tile'),
    //           carousel_index: idx,
    //           link_url: e.target.href
    //         });
    //       });
    //     }
    //   });
    // }
    // CTA click event for the hero carousel items.
    let carouselHeros = document.querySelectorAll('.txrh-hero-carousel .slick-slide .carousel-item__hero-carousel .paragraph--type--cta .field-item__field-link a');
    if ( carouselHeros.length ) {

      carouselHeros.forEach(function(el){
        let slide = el.parentNode.parentNode.parentNode.parentNode.parentNode.parentNode.parentNode;
        el.addEventListener('click', function(e){
          let idx = parseInt(slide.getAttribute('id').replace(/slick-slide/, ''))+1;
          let carousel_tile = slide.querySelectorAll('.slide-title')[0].textContent;
          console.log('Carousel HERO Click', carousel_tile);
          dataLayer.push({
            event:'cta_click',
            link_text: e.target.textContent,
            site_section: 'Hero Carousel',
            carousel_tile: carousel_tile,
            carousel_index: idx,
            link_url: e.target.href
          });
        });
      });
    }

    document.querySelectorAll('.page-node-type-vendor-stores .cta-ordering.cta-vendor-store-links > a').forEach(function(value, index){
      value.addEventListener('click', function (event){
        event.preventDefault();
        let textValue = event.target.innerHTML.toLowerCase().replace('-', ' ');
        dataLayer.push({
          event: 'cta_click',
          link_text: textValue,
          page_title: 'location'
        });
        window.location.href = event.target.href;
      });
    });

  }

})(Drupal, once);
